"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDetailedIcon = void 0;
var _DetailedIcon = require("./DetailedIcon");
// TODO: in v9, move styled() from DetailedIcon.jsx to here
var StyledDetailedIcon = _DetailedIcon.DetailedIcon;
exports.StyledDetailedIcon = StyledDetailedIcon;